export default __webpack_public_path__ + "static/media/last-map-update.daa9b3ef.png";